/**
 * Created by Ivan on 07.07.2026
 */

const PuzzlesComponent = function (collection) {
    return Prefab.instantiate(bundles.stickers_collection_window.jsons.puzzles_component_prefab_json, { collection });
};
